import { render, staticRenderFns } from "./ErrorBubble.vue?vue&type=template&id=4fa24feb&scoped=true&"
import script from "./ErrorBubble.vue?vue&type=script&lang=js&"
export * from "./ErrorBubble.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBubble.vue?vue&type=style&index=0&id=4fa24feb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa24feb",
  null
  
)

export default component.exports